/**
 * @desc
 * - displays get started page if no allowed apps
 */
;(function () {
  angular
    .module('contrast.get_started')
    .directive('csGetStarted', [csGetStarted])

  function csGetStarted() {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      templateUrl: 'views/common/get_started.html',
      controller: 'csGetStartedCtrl',
      controllerAs: 'getStartedCtrl',
      link: link
    }

    function link(scope, element, attrs, controller) {
      var entityType = attrs.csEntityType || 'application'
      var checkSampleData = attrs.csCheckSampleData
        ? attrs.csCheckSampleData == 'true'
        : true

      controller.setDirectiveProps(entityType, checkSampleData)
    }
  }
})()
